<app-header title="SDS" subTitle=""></app-header>
<div class="main-container">
  <div class="header">
    <h1>SDS Search History</h1>
  </div>
  <div class="options-container">
    <form [formGroup]="searchForm" novalidate>
      <div class="mb-3 flex search-box">
        <span class="px-3 font-semibold">Search Date</span>
        <p-calendar
          [showButtonBar]="true"
          [(ngModel)]="date"
          formControlName="selectedDates"
          [readonlyInput]="true"
          [showIcon]="true"
          [styleClass]="'custom-height'"
        ></p-calendar>
        <span class="px-3 font-semibold u-name">User Name</span>
        <input
          type="text"
          pInputText
          placeholder="Search with user name"
          formControlName="textValue"
          pInputText
        />
        <p-button
          class="ml-3"
          label="Search"
          (click)="handleGetSearchList()"
        ></p-button>
        <p-button class="ml-2" label="Clear" (click)="clearText()"></p-button>
      </div>
    </form>
  </div>
  <div
    *ngIf="searchTracks.length === 0 && !firstTimeSearch"
    class="no_result__text"
  >
    <div class="home__img">
      <img
        class="no_result___image"
        loading="lazy"
        src="../../../../../assets/no_result_admins.png"
        alt="no result image"
      />
    </div>
    <div class="no_result_text">No results found</div>
    <div class="no_result__subtext">
      Try adjusting your search or filter to find what you are looking for
    </div>
  </div>
  <p-table
    *ngIf="searchTracks.length > 0"
    [columns]="columns"
    [value]="searchTracks"
    [paginator]="true"
    styleClass="p-datatable-lg"
    [rows]="15"
    [showCurrentPageReport]="true"
    [loading]="isSearchListFetching && !firstTimeSearch"
    [loadingIcon]="'pi pi-spinner pi-spin'"
    currentPageReportTemplate="{first} - {last} of {totalRecords} items"
    class="custom-table"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngFor="let col of columns"
          [pSortableColumn]="col.sortable ? col.field : null"
        >
          {{ col.name }}
          <p-sortIcon
            *ngIf="col.sortable"
            [field]="col.field"
            (click)="onSort(col.field)"
            class="custom-sort-icon"
          ></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-loginTrack let-columns="columns">
      <tr class="row-separator">
        <td *ngFor="let col of columns">
          {{ loginTrack[col.field] }}
        </td>
      </tr></ng-template
    >
  </p-table>
</div>
